// Action Types

import { data } from "jquery"

export const Types = {
  GET_MONTHLY_RESULT_REQUESTED: 'financial/GET_MONTHLY_RESULT_REQUESTED',
  GET_MONTHLY_RESULT_SUCCEEDED: 'financial/GET_MONTHLY_RESULT_SUCCEEDED',
  GET_MONTHLY_RESULT_FAILED: 'financial/GET_MONTHLY_RESULT_FAILED',

  GET_INCOME_REQUESTED: 'financial/GET_INCOME_REQUESTED',
  GET_INCOME_SUCCEEDED: 'financial/GET_INCOME_SUCCEEDED',
  GET_INCOME_FAILED: 'financial/GET_INCOME_FAILED',

  GET_EXPENSE_REQUESTED: 'financial/GET_EXPENSE_REQUESTED',
  GET_EXPENSE_SUCCEEDED: 'financial/GET_EXPENSE_SUCCEEDED',
  GET_EXPENSE_FAILED: 'financial/GET_EXPENSE_FAILED',
}

// Action Creators

export function getMonthlyResult(mes, escopo) {
  return {
    type: Types.GET_MONTHLY_RESULT_REQUESTED,
    mes,
    escopo,
  }
}

export function getIncome() {
  return {
    type: Types.GET_INCOME_REQUESTED,
  }
}

export function getExpense() {
  return {
    type: Types.GET_EXPENSE_REQUESTED,
  }
}

// Reducer

const INITIAL_STATE = {
  getMonthlyResultIsLoading: false,
  getMonthlyResultError: null,
  monthlyResult: null,

  getIncomeIsLoading: false,
  getIncomeError: null,
  income: null,

  getExpenseIsLoading: false,
  getExpenseError: null,
  expense: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_MONTHLY_RESULT_REQUESTED:
      return {
        ...state,
        getMonthlyResultIsLoading: true,
      }
    case Types.GET_MONTHLY_RESULT_SUCCEEDED:
      return {
        ...state,
        getMonthlyResultIsLoading: false,
        getMonthlyResultError: null,
        monthlyResult: action.payload,
      }
    case Types.GET_MONTHLY_RESULT_FAILED:
      return {
        ...state,
        getMonthlyResultIsLoading: false,
        getMonthlyResultError: action.payload,
        monthlyResult: null,
      }
    case Types.GET_INCOME_REQUESTED:
      return {
        ...state,
        getIncomeIsLoading: true,
      }
    case Types.GET_INCOME_SUCCEEDED:
      return {
        ...state,
        getIncomeIsLoading: false,
        getIncomeError: null,
        income: action.payload,
      }
    case Types.GET_INCOME_FAILED:
      return {
        ...state,
        getIncomeIsLoading: false,
        getIncomeError: action.payload,
        income: null,
      }
    case Types.GET_EXPENSE_REQUESTED:
      return {
        ...state,
        getExpenseIsLoading: true,
      }
    case Types.GET_EXPENSE_SUCCEEDED:
      return {
        ...state,
        getExpenseIsLoading: false,
        getExpenseError: null,
        expense: action.payload,
      }
    case Types.GET_EXPENSE_FAILED:
      return {
        ...state,
        getExpenseIsLoading: false,
        getExpenseError: action.payload,
        expense: null,
      }

    default:
      return state
  }
}
